import React, { useState } from 'react';
import { GiftIcon, PlusIcon } from 'lucide-react';
import { Collapsible } from './Collapsible';
import { bonos } from '../data/bonos';
export function BonosSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-ink-900 px-4 py-11 text-cream sm:px-8 sm:py-16 lg:py-20" data-id="element-9" data-mp="13btegsj8x42f">
      <div className="mx-auto max-w-6xl" data-id="element-10" data-mp="ycqhzwhc0662">
        <div className="flex items-start gap-3" data-id="element-11" data-mp="tg9jq9gf4bf9">
          <GiftIcon className="mt-1 h-6 w-6 shrink-0 text-gold sm:h-8 sm:w-8" aria-hidden="true" data-id="element-12" data-mp="th1fbka0m95j" />
          <div data-id="element-13" data-mp="kes4sueqyfs5">
            <h2 className="font-display text-2xl font-extrabold leading-tight sm:text-4xl" data-id="element-14" data-mp="kejth6y9vij2">
              Y como si fuera poco... te llevás 5 bonos gratis
            </h2>
            <p className="mt-2 max-w-2xl font-sans text-sm text-cream-200/90 sm:text-base" data-id="element-15" data-mp="2et2sv0nip5wv">
              Recursos prácticos para esos momentos en los que necesitás una
              propuesta concreta y no tenés tiempo que perder.
            </p>
          </div>
        </div>

        <ul className="mt-5 grid grid-cols-1 gap-2 sm:mt-8 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3" data-id="element-16" data-mp="qxiq4qn4ftfy">
          {bonos.map((bono, index) => {
          const isOpen = openIndex === index;
          return <li key={bono.numero} className={`flex h-full flex-col overflow-hidden rounded-xl border bg-ink-800 transition-colors duration-150 ease-out sm:rounded-2xl ${isOpen ? 'border-gold/60' : 'border-cream/10'}`} data-id="element-17" data-mp="hx2qjs9i16gd" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`bono-panel-${index}`} className="flex w-full items-start gap-3 p-2.5 text-left transition-colors duration-150 ease-out hover:bg-ink-700 sm:p-3" data-id="element-18" data-mp="10tlqps2brk0s">
                  <img src={bono.imagen} alt="" aria-hidden="true" loading="lazy" decoding="async" width={112} height={112} className="h-12 w-12 shrink-0 rounded-lg bg-cream object-cover sm:h-16 sm:w-16" data-id="element-19" data-mp="1yb2l0npks3w8" />
                  <span className="min-w-0 flex-1" data-id="element-20" data-mp="1t7645klxn4hm">
                    <span className="flex items-center justify-between gap-2" data-id="element-21" data-mp="1p6m5gclpnstd">
                      <span className="font-sans text-[9px] font-bold uppercase tracking-[0.14em] text-gold-400 sm:text-[11px]" data-id="element-22" data-mp="1kfduhc4qfze3">
                        Bono #{bono.numero} · Gratis
                      </span>
                      <PlusIcon className={`h-3.5 w-3.5 shrink-0 text-cream-300 transition-transform duration-200 ease-out sm:h-4 sm:w-4 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-23" data-mp="1ahg8ywe9cgp6" />
                    </span>
                    <span className="mt-1 block font-display text-[13px] font-bold leading-tight text-cream sm:text-base" data-id="element-24" data-mp="3d33dpqgp4r80">
                      {bono.titulo}
                    </span>
                  </span>
                </button>

                <Collapsible id={`bono-panel-${index}`} open={isOpen} data-id="element-25" data-mp="3m2gtt1zbse1p">
                  <p className="px-2.5 pb-3 font-sans text-xs leading-relaxed text-cream-200/90 sm:px-3 sm:text-sm" data-id="element-26" data-mp="3r34g5acm06pl">
                    {bono.descripcion}
                  </p>
                </Collapsible>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}